export default function (state) {
    let filter = state.filters.filter(i => {
        return i.id === state.filter;
    })[0];
    if (!filter) return 365;
    switch (filter.dateStep) {
        case 1:
            return 365;
        case 2:
            return 52;
        case 3:
            return 12;
    }
    return 365;
}